var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRectangleRoundCorners = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64.33 50.9H31.77a2.761 2.761 0 0 1-2.87-2.65V31.67a2.691 2.691 0 0 1 2.8-2.57h32.48A2.699 2.699 0 0 1 67 31.65v16.58c.03 1.44-1.1 2.63-2.54 2.66h-.13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.65 51.86A3.727 3.727 0 0 1 28 48.27v-16.6c.09-2 1.76-3.56 3.76-3.53h32.42A3.675 3.675 0 0 1 68 31.62v16.61a3.575 3.575 0 0 1-3.5 3.62H31.65Zm0-21.8c-.93 0-1.7.73-1.75 1.66v16.52c.04.99.85 1.77 1.84 1.77H64.4c.92-.03 1.63-.8 1.6-1.72V31.67c-.07-.94-.88-1.66-1.82-1.62H31.65Z"
  })));
};
export default SvgRectangleRoundCorners;